export const color = {
  white: "#ffffff",
  lightBlue: "#008dbf",
  red: "#ff425f",
  yellow: "#ffee00",
};
